import { useApiBase } from "api/base";
import { useCallback } from "react";

export function useGetMovimentoById() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getMovimentoById = useCallback(
        (empresaId: string, movimentoId: string) => {
            return invocarApi({
                url: `v4/empresa/${empresaId}/movimento/${movimentoId}`,
                method: "GET",
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        getMovimentoById,
    };
}